import { Alert } from "@gravity-ui/uikit";
import { OrderList } from "definitions/poizon-api";
import { useMemo } from "react";

import { OrderViews } from "../../store/atoms/orderListView";
import { OrderComponentTable } from "../OrderComponentTable/OrderComponentTable";
import { OrderComponentTile } from "../OrderComponentTile/OrderComponentTile";
import css from "./OrderListComponent.module.scss";

interface OrderListProps {
  responseData: OrderList[] | null;
  isLoading: boolean;
  ordersViewValue: OrderViews;
}

export const OrderListComponent = ({
  responseData,
  isLoading,
  ordersViewValue,
}: OrderListProps) => {
  const orderList = useMemo(() => responseData ?? [], [responseData]);

  if (!responseData)
    return (
      <Alert
        theme="danger"
        title="Ошибка"
        message="Не удалось загрузить данные."
      />
    );
  if (!isLoading && orderList.length == 0)
    return <Alert title="Ничего не найдено!" />;
  return (
    <div className={css.mainContainer}>
      {orderList.map((order, index) => {
        const OrderComponentType = getOrderComponent(ordersViewValue);
        return (
          <OrderComponentType
            order={order}
            key={`order_${order.orderNo}_${index}`}
            view={ordersViewValue}
          />
        );
      })}
    </div>
  );
};

const getOrderComponent = (view: OrderViews) => {
  switch (view) {
    case "table":
      return OrderComponentTable;
    case "tile":
      return OrderComponentTile;
    default:
      throw "UnknownType";
  }
};
